import "./theme.scss";
import "./App.scss";

import iso_3166 from "iso-3166-1";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";

import { fetchStats } from "./actions";
import { fetchActiveChannels } from "./actions/channel";
import { fetchUser } from "./actions/user";
import Footer from "./components/Footer";
import SearchBar from "./components/SearchBar";
import ActiveChannels from "./containers/ActiveChannels";
import BulkActivation from "./containers/BulkActivation";
import Channel from "./containers/Channel";
import ChannelSearch from "./containers/ChannelSearch";
import weathersvlogo from "./images/weathersvlogo.png";
import { getActiveChannels } from "./selectors/channel";

// Patch in support for Kosovo... the country that doesn't exist
iso_3166._whereAlpha2 = iso_3166.whereAlpha2;
iso_3166.whereAlpha2 = (alpha2) => {
  if (alpha2 === "XK") {
    return { country: "Kosovo", alpha2: "XK", alpha3: "XK", numeric: 0 };
  }
  return iso_3166._whereAlpha2(alpha2);
};
// End hacking a country into existence

const PageLogo = () => (
  <a href="/">
    <img src={weathersvlogo} alt="WeatherSV Logo" className="logo" />
  </a>
);

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  async componentDidMount() {
    this.props.fetchStats();
    this.props.fetchActiveChannels();
    this.props.fetchUser();
  }

  handleSearch(city) {
    const { history } = this.props;
    history.push({ pathname: "/find", search: `?city=${city}` });
  }

  render() {
    const { total_transactions } = this.props.settings.stats;
    const { active } = this.props;

    return (
      <div id="page-container">
        <div id="header">
          <Switch>
            <Route path="/channel">
              <div className="left-content">
                <div className="vertical-center">
                  <PageLogo />
                </div>
              </div>
              <div className="right-content">
                <SearchBar
                  onSubmit={this.handleSearch}
                  label="Find local Weather"
                />
              </div>
            </Route>
            <Route path="/">
              <div className="vertical-center horizontal-center">
                <PageLogo />
              </div>
            </Route>
          </Switch>
        </div>
        <div id="content">
          <div className="content horizontal-center">
            <Switch>
              <Route path="/inactive">
                <BulkActivation />
              </Route>
              <Route path="/channel/:id">
                <Channel />
              </Route>
              <Route exact path="/channel">
                <ActiveChannels />
              </Route>
              <Route path="/find">
                <p>
                  Search your suburb, city or town for nearby channels from over
                  200,000 live weather stations.
                </p>
                <div className="searchcontainer">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <h2>Find local weather</h2>
                    <SearchBar onSubmit={this.handleSearch} />
                  </div>
                  <ChannelSearch />
                </div>
              </Route>
              <Route path="/">
                <Redirect to="/find" />
              </Route>
            </Switch>
          </div>
        </div>
        <Footer
          id="footer"
          totalBroadcast={total_transactions}
          numActive={active.length}
        />
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      active: getActiveChannels(state),
      settings: state.settings,
    }),
    { fetchActiveChannels, fetchUser, fetchStats }
  )(App)
);
